import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as moment from "moment-timezone";
import Login from '../common/login';

const cookies = new Cookies();

const STATUS = {
    0: 'انتظار', 1: 'مطبوع', 2: 'ملغى',
    3: 'منجَح', 4: 'راجع', 5: 'ما انتصل بيه'
};
const STATUS_TONE = { 0: 'info', 1: 'info', 2: 'bad', 3: 'ok', 4: 'warn', 5: 'warn' };

const fmtDate = (d) => {
    if (!d) return '—';
    try { return moment(d).tz('Asia/Baghdad').format('YYYY-MM-DD HH:mm'); }
    catch (e) { return String(d).slice(0, 16).replace('T', ' '); }
};

class SuccessLists extends React.Component {
    constructor(props) {
        super(props);
        const q = new URLSearchParams(window.location.search);
        const qid = parseInt(String(q.get('id') || '').replace(/[^0-9]/g, ''), 10);
        this.state = {
            openId: (isFinite(qid) && qid > 0) ? qid : null,
            lists: [],
            loadingLists: true,
            detail: null,       // { list, items }
            loadingDetail: false,
            reverting: false,
            from: '', to: ''
        };
    }

    componentDidMount() {
        this.loadLists();
        if (this.state.openId) this.loadDetail(this.state.openId);
    }

    headers = () => ({ "Content-Type": "application/json", token: cookies.get("token") });

    loadLists = () => {
        const { from, to } = this.state;
        const qs = [];
        if (from) qs.push('from=' + from);
        if (to) qs.push('to=' + to);
        this.setState({ loadingLists: true });
        axios.get(host + `users/success/lists${qs.length ? '?' + qs.join('&') : ''}`, { headers: this.headers() })
            .then(res => this.setState({
                lists: (res.data.data && res.data.data.lists) || [], loadingLists: false
            }))
            .catch(err => {
                console.log(err.response);
                this.setState({ loadingLists: false });
                toast.error('تعذّر جلب الكشوفات', { position: "top-center", autoClose: 4000 });
            });
    }

    loadDetail = (id) => {
        this.setState({ loadingDetail: true, openId: id, detail: null });
        axios.get(host + `users/success/list/${id}`, { headers: this.headers() })
            .then(res => this.setState({ detail: res.data.data, loadingDetail: false }))
            .catch(err => {
                console.log(err.response);
                this.setState({ loadingDetail: false });
                toast.error('تعذّر جلب الكشف', { position: "top-center", autoClose: 4000 });
            });
    }

    open = (id) => {
        if (window.history && window.history.pushState) {
            window.history.pushState({}, '', `/successLists?id=${id}`);
        }
        this.loadDetail(id);
    }

    back = () => {
        if (window.history && window.history.pushState) {
            window.history.pushState({}, '', `/successLists`);
        }
        this.setState({ openId: null, detail: null });
        this.loadLists();
    }

    revert = () => {
        const d = this.state.detail;
        if (!d || !d.list || this.state.reverting) return;

        const msg = `راح يترجّع ${d.list.orders_count} طلب لحالته قبل الإنجاح.\n`
            + `كشف رقم ${d.list.id} — ${fmtDate(d.list.createdAt)}\n\nتكمّل؟`;
        if (!window.confirm(msg)) return;

        this.setState({ reverting: true });
        axios.post(host + `users/success/list/${d.list.id}/revert`, {
            admin_name: (typeof localStorage !== 'undefined' && localStorage.getItem('name')) || ''
        }, { headers: this.headers() })
            .then(res => {
                const r = (res.data && res.data.data) || {};
                this.setState({ reverting: false });
                toast.success(r.msg || 'تم الفكّ', { position: "top-center", autoClose: 6000 });
                this.loadDetail(d.list.id);
                this.loadLists();
            })
            .catch(err => {
                console.log(err.response);
                this.setState({ reverting: false });
                const m = (err.response && err.response.data && err.response.data.message)
                    ? err.response.data.message : 'تعذّر فكّ الكشف';
                toast.error(m, { position: "top-center", autoClose: 6000 });
            });
    }

    render() {
        if (!cookies.get("token")) return <Login />;
        const s = this.state;
        const d = s.detail;

        return (
            <Context.Consumer>{ctx => (
                <div className="sl">
                    <style>{`
.sl { direction:rtl; text-align:right; padding:20px 24px 70px;
  --ink:#16202E; --ink2:#64748B; --line:#E6EBF2; --wash:#F8FAFC;
  --ok:#12734C; --warn:#B4530C; --bad:#C0341D; --info:#2450C8; --pick:#0E7C6B;
  color:var(--ink); font-family:'Segoe UI','Noto Kufi Arabic',Tahoma,sans-serif;
  font-size:14px; line-height:1.5; }
.sl .n { font-variant-numeric: tabular-nums; }
.sl-eyebrow { font-size:11px; font-weight:700; letter-spacing:.12em; color:var(--ink2); }

.sl-top { display:flex; align-items:center; gap:14px; flex-wrap:wrap; margin-bottom:16px; }
.sl-top h2 { margin:0; font-size:22px; font-weight:800; letter-spacing:-.01em; }
.sl-top p { margin:0; font-size:13px; color:var(--ink2); }
.sl-top-act { margin-right:auto; display:flex; align-items:center; gap:9px; }

.sl-in { border:1px solid #CBD5E1; border-radius:8px; padding:7px 11px; font-size:14px;
  background:#fff; color:var(--ink); font-family:inherit; }
.sl-in:focus-visible { outline:2px solid var(--info); outline-offset:1px; }
.sl-btn { border:none; border-radius:8px; padding:9px 18px; font-size:14px; font-weight:700;
  background:var(--ink); color:#fff; cursor:pointer; font-family:inherit; }
.sl-btn:disabled { background:#C3CDDA; cursor:not-allowed; }
.sl-btn.is-ghost { background:none; border:1px solid #CBD5E1; color:var(--ink2); font-weight:600; }
.sl-btn.is-ghost:hover { border-color:#94A3B8; color:var(--ink); }
.sl-btn.is-danger { background:var(--bad); }
.sl-btn.is-add { background:var(--pick); display:inline-flex; align-items:center; gap:7px;
  text-decoration:none; }
.sl-btn.is-add:hover { background:#0B6357; color:#fff; }
.sl-plus { font-size:17px; font-weight:800; line-height:1; }

/* ══ لوحة الكشف ══ */
.sl-band { background:var(--ink); border-radius:14px; padding:18px 22px;
  margin-bottom:14px; color:#E8EEF6; }
.sl-band-row { display:flex; align-items:flex-end; gap:34px; flex-wrap:wrap; }
.sl-b-main { display:flex; flex-direction:column; }
.sl-b-main span { font-size:11px; font-weight:700; letter-spacing:.11em; color:#8FA3BD; }
.sl-b-main b { font-size:40px; font-weight:800; line-height:1.05; letter-spacing:-.03em;
  font-variant-numeric: tabular-nums; }
.sl-b-main em { font-style:normal; font-size:13px; color:#A9BBD1; margin-top:2px; }
.sl-b-item { display:flex; flex-direction:column; padding-bottom:5px; }
.sl-b-item span { font-size:11px; font-weight:700; letter-spacing:.11em; color:#8FA3BD; }
.sl-b-item b { font-size:21px; font-weight:800; font-variant-numeric: tabular-nums;
  letter-spacing:-.02em; }
.sl-b-item b.is-zero { color:#35B37E; } .sl-b-item b.is-off { color:#E2A03F; }
.sl-b-act { margin-right:auto; display:flex; align-items:center; gap:10px; padding-bottom:4px; }
.sl-b-act .sl-btn.is-ghost { border-color:#33435C; color:#A9BBD1; background:none; }
.sl-b-act .sl-btn.is-ghost:hover { border-color:#4A5E7A; color:#E8EEF6; }
.sl-revoked { margin-top:12px; padding:9px 13px; border-radius:9px; font-size:13px;
  background:#3A2320; border:1px solid #6B3B34; color:#F0BBB2; }

/* ══ الجداول ══ */
.sl-card { border:1px solid var(--line); border-radius:12px; overflow:hidden; background:#fff; }
.sl-card-head { display:flex; align-items:center; gap:12px; flex-wrap:wrap;
  padding:10px 16px; background:var(--wash); border-bottom:1px solid var(--line); }
.sl-scroll { max-height:560px; overflow:auto; }
.sl-t { width:100%; border-collapse:collapse; font-size:13.5px; }
.sl-t th { position:sticky; top:0; background:#fff; z-index:1; text-align:right;
  padding:9px 12px; font-size:11px; font-weight:700; letter-spacing:.05em;
  color:var(--ink2); border-bottom:1px solid var(--line); white-space:nowrap; }
.sl-t td { padding:8px 12px; border-bottom:1px solid #F1F5F9; }
.sl-t td.c { text-align:center; font-variant-numeric: tabular-nums; }
.sl-t tr.is-click { cursor:pointer; }
.sl-t tr.is-click:hover td { background:#F6F9FC; }
.sl-t tr.is-off td { background:#FCFCFD; color:var(--ink2); }
.sl-no { font-weight:800; font-variant-numeric: tabular-nums; }
.sl-tag { display:inline-block; padding:1px 9px; border-radius:999px;
  font-size:11px; font-weight:700; border:1px solid; white-space:nowrap; }
.sl-tag.ok { color:var(--ok); border-color:#BFE3D2; background:#F1F9F5; }
.sl-tag.warn { color:var(--warn); border-color:#F0D4A8; background:#FFF8EE; }
.sl-tag.info { color:var(--info); border-color:#D3DEF2; background:#F4F7FD; }
.sl-tag.bad { color:var(--bad); border-color:#F3C4BB; background:#FDECE9; }
.sl-delta { font-weight:700; font-variant-numeric: tabular-nums; }
.sl-delta.up { color:var(--ok); } .sl-delta.down { color:var(--bad); }
.sl-empty { padding:44px 16px; text-align:center; color:var(--ink2); font-size:14px; }
                    `}</style>

                    {/* ══════════ قائمة الكشوفات ══════════ */}
                    {!s.openId && (
                        <div>
                            <div className="sl-top">
                                <h2>كشوفات الإنجاح</h2>
                                <p>كل عملية إنجاح مسجّلة بعددها وتاريخها</p>
                                <div className="sl-top-act">
                                    <a className="sl-btn is-add" href="/successOrders">
                                        <span className="sl-plus">+</span> كشف إنجاح جديد
                                    </a>
                                    <input type="date" className="sl-in" value={s.from}
                                        onChange={(e) => this.setState({ from: e.target.value }, this.loadLists)} />
                                    <input type="date" className="sl-in" value={s.to}
                                        onChange={(e) => this.setState({ to: e.target.value }, this.loadLists)} />
                                    {(s.from || s.to) && (
                                        <button className="sl-btn is-ghost"
                                            onClick={() => this.setState({ from: '', to: '' }, this.loadLists)}>
                                            مسح
                                        </button>
                                    )}
                                </div>
                            </div>

                            <div className="sl-card">
                                <div className="sl-card-head">
                                    <span className="sl-eyebrow">الكشوفات</span>
                                    <span style={{ fontSize: 12, color: '#64748B' }}>{s.lists.length} كشف</span>
                                </div>
                                {s.loadingLists ? (
                                    <div className="sl-empty">جاري التحميل…</div>
                                ) : s.lists.length === 0 ? (
                                    <div className="sl-empty">
                                        <p style={{ margin: '0 0 14px' }}>ما فيه كشوفات بعد</p>
                                        <a className="sl-btn is-add" href="/successOrders">
                                            <span className="sl-plus">+</span> ارفع كشف شركة التوصيل
                                        </a>
                                    </div>
                                ) : (
                                    <div className="sl-scroll">
                                        <table className="sl-t">
                                            <thead>
                                                <tr>
                                                    <th className="c" style={{ width: 70 }}>الكشف</th>
                                                    <th>التاريخ</th>
                                                    <th className="c">الطلبات</th>
                                                    <th className="c">مجموع الاكسل</th>
                                                    <th className="c">مجموع النظام</th>
                                                    <th className="c">أسعار مختلفة</th>
                                                    <th>المُدخِل</th>
                                                    <th>الملف</th>
                                                    <th>الحالة</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {s.lists.map(l => (
                                                    <tr key={l.id}
                                                        className={'is-click ' + (l.is_reverted ? 'is-off' : '')}
                                                        onClick={() => this.open(l.id)}>
                                                        <td className="c sl-no">#{l.id}</td>
                                                        <td className="n">{fmtDate(l.createdAt)}</td>
                                                        <td className="c sl-no">{l.orders_count}</td>
                                                        <td className="c">{l.excel_total}</td>
                                                        <td className="c">{l.sys_total}</td>
                                                        <td className="c">
                                                            {l.diff_count > 0
                                                                ? <span className="sl-tag warn">{l.diff_count}</span>
                                                                : <span style={{ color: '#94A3B8' }}>—</span>}
                                                        </td>
                                                        <td>{l.admin_name || '—'}</td>
                                                        <td style={{ fontSize: 12, color: '#64748B', maxWidth: 210,
                                                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                            {l.file_name || '—'}
                                                        </td>
                                                        <td>
                                                            {l.is_reverted
                                                                ? <span className="sl-tag bad">مفكوك</span>
                                                                : <span className="sl-tag ok">نشط</span>}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {/* ══════════ تفاصيل كشف ══════════ */}
                    {s.openId && (
                        <div>
                            <div className="sl-top">
                                <button className="sl-btn is-ghost" onClick={this.back}>→ كل الكشوفات</button>
                                <h2>كشف #{s.openId}</h2>
                                {d && d.list && <p>{fmtDate(d.list.createdAt)}</p>}
                            </div>

                            {s.loadingDetail ? (
                                <div className="sl-card"><div className="sl-empty">جاري التحميل…</div></div>
                            ) : !d ? (
                                <div className="sl-card"><div className="sl-empty">الكشف غير موجود</div></div>
                            ) : (
                                <div>
                                    <div className="sl-band">
                                        <div className="sl-band-row">
                                            <div className="sl-b-main">
                                                <span>الطلبات</span>
                                                <b>{d.list.orders_count}</b>
                                                <em>{d.list.admin_name || 'بلا اسم'} · {d.list.file_name || 'بلا ملف'}</em>
                                            </div>
                                            <div className="sl-b-item">
                                                <span>مجموع الاكسل</span>
                                                <b>{d.list.excel_total}</b>
                                            </div>
                                            <div className="sl-b-item">
                                                <span>مجموع النظام</span>
                                                <b>{d.list.sys_total}</b>
                                            </div>
                                            <div className="sl-b-item">
                                                <span>الفرق</span>
                                                <b className={Math.abs(d.list.excel_total - d.list.sys_total) < 0.001 ? 'is-zero' : 'is-off'}>
                                                    {Math.round((d.list.excel_total - d.list.sys_total) * 100) / 100}
                                                </b>
                                            </div>
                                            <div className="sl-b-item">
                                                <span>أسعار مختلفة</span>
                                                <b className={d.list.diff_count > 0 ? 'is-off' : 'is-zero'}>
                                                    {d.list.diff_count}
                                                </b>
                                            </div>
                                            <div className="sl-b-act">
                                                {!d.list.is_reverted && (
                                                    <button className="sl-btn is-danger"
                                                        disabled={s.reverting}
                                                        onClick={this.revert}>
                                                        {s.reverting ? 'جاري الفكّ…' : 'فكّ الكشف كله'}
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {d.list.is_reverted && (
                                            <div className="sl-revoked">
                                                ⛔ هذا الكشف مفكوك — {fmtDate(d.list.reverted_at)}
                                                {d.list.reverted_by ? ` · ${d.list.reverted_by}` : ''}.
                                                الطلبات رجعت لحالتها قبل الإنجاح.
                                            </div>
                                        )}
                                    </div>

                                    <div className="sl-card">
                                        <div className="sl-card-head">
                                            <span className="sl-eyebrow">طلبات الكشف</span>
                                            <span style={{ fontSize: 12, color: '#64748B' }}>
                                                {(d.items || []).length} طلب · الحالة معروضة كما هي الآن
                                            </span>
                                        </div>
                                        <div className="sl-scroll">
                                            {(d.items || []).length === 0 ? (
                                                <div className="sl-empty">الكشف فارغ</div>
                                            ) : (
                                                <table className="sl-t">
                                                    <thead>
                                                        <tr>
                                                            <th className="c">رقم الوصل</th>
                                                            <th>الزبون</th>
                                                            <th>العنوان</th>
                                                            <th className="c">سعر الاكسل</th>
                                                            <th className="c">سعر النظام وقتها</th>
                                                            <th className="c">الفرق</th>
                                                            <th className="c">قبل الإنجاح</th>
                                                            <th>الحالة الآن</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {d.items.map(it => {
                                                            const ex = it.excel_price === null ? null : Number(it.excel_price);
                                                            const sy = it.sys_price === null ? null : Number(it.sys_price);
                                                            const dl = (ex === null || sy === null)
                                                                ? null : Math.round((ex - sy) * 1000) / 1000;
                                                            const st = Number(it.status);
                                                            return (
                                                                <tr key={it.id}>
                                                                    <td className="c sl-no">{it.id}</td>
                                                                    <td>{it.name || '—'}</td>
                                                                    <td style={{ fontSize: 12, color: '#64748B' }}>
                                                                        {it.government ? `${it.government} / ${it.city}` : '—'}
                                                                    </td>
                                                                    <td className="c">{ex === null ? '—' : ex}</td>
                                                                    <td className="c">{sy === null ? '—' : sy}</td>
                                                                    <td className="c">
                                                                        {!dl ? '—' : (
                                                                            <span className={'sl-delta ' + (dl > 0 ? 'up' : 'down')}>
                                                                                {dl > 0 ? '+' : ''}{dl}
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td className="c" style={{ fontSize: 12, color: '#64748B' }}>
                                                                        {STATUS[it.prev_status] || '—'}
                                                                    </td>
                                                                    <td>
                                                                        <span className={'sl-tag ' + (STATUS_TONE[st] || 'info')}>
                                                                            {STATUS[st] || st}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    <ToastContainer position="bottom-left" autoClose={5000} rtl={false} />
                </div>
            )}</Context.Consumer>
        );
    }
}

export default SuccessLists;
